import React, { useCallback, useEffect, useState } from "react";
import { Calendar, Notification } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { useContent, NewsItem } from "../../hooks/content";

import {
  Body,
  EmptyState,
  MetaRow,
  MetaText,
  NewsCard,
  NewsDescription,
  NewsTitle,
} from "./styles";

function formatDate(iso?: string): string {
  if (!iso) return "Recente";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Recente";
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const UserNews: React.FC = () => {
  const { listNews } = useContent();
  const [items, setItems] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await listNews();
      const published = data
        .filter((item) => item.published !== false)
        .sort((a, b) => (b.createdAt || "").localeCompare(a.createdAt || ""));
      setItems(published);
    } catch (error) {
      console.error(error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [listNews]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <MobileLayout
      headerTitle="Avisos"
      headerType="private"
      headerDescription="Notícias e comunicados"
    >
      <Body>
        {loading && (
          <p style={{ textAlign: "center", color: "#64748B" }}>Carregando...</p>
        )}

        {!loading && items.length === 0 && (
          <EmptyState>
            <Notification size={48} color="#6E6A7C" variant="Linear" />
            <h2>Nenhum aviso no momento</h2>
            <p>Quando houver novidades, elas aparecerão aqui.</p>
          </EmptyState>
        )}

        {!loading &&
          items.map((item) => (
            <NewsCard key={item.uid}>
              <NewsTitle>{item.title}</NewsTitle>
              <NewsDescription>{item.description}</NewsDescription>
              <MetaRow>
                <Calendar size={16} color="#6E6A7C" />
                <MetaText>{formatDate(item.createdAt)}</MetaText>
              </MetaRow>
            </NewsCard>
          ))}
      </Body>
    </MobileLayout>
  );
};

export default UserNews;
